import React, { useMemo, useState } from 'react';
import { useSearchStateLocation } from './hooks/useSearchStateLocation';
import IconCaret from '../ui/icons/IconCaret';
import SearchFiltersCities from './SearchFiltersCities';
import { useCurrentRefinements } from 'react-instantsearch-hooks-web';
import { Desktop, TabletAndBelow } from '../ui/Responsive';

const SearchCitySelector = () => {
	const { submarket, stateAsLocation } = useSearchStateLocation();
	const [ isCitiesOpen, setIsCitiesOpen ] = useState( true );
	const { items, canRefine, refine } = useCurrentRefinements();

	const selectedCitiesCount = useMemo( () => {
		const cityFilters = items.find( ( item ) => item.attribute === 'cities' );
		return ! cityFilters ? 0 : cityFilters.refinements.length;
	}, [ items ] );

	return (
		<div className="tw-shadow tw-px-6 tw-pt-6 tw-pb-4 tw-mt-8">
			<div className='tw-relative'>
				<div className='tw-flex tw-items-center tw-mr-8 lg:tw-mr-0'>
					<h4 className="tw-text-charcoal tw-text-base lg:tw-text-lg tw-font-normal tw-mb-2 tw-block lg:tw-flex">
						<span>
							Where We Build in
							{submarket.submarket && ( ` ${ submarket.submarket }, ${ submarket.stateAbbreviation }` )}
							{stateAsLocation.name && ( ` ${ stateAsLocation.name }` )}
						</span>
						{selectedCitiesCount > 0 && (
							<span className='tw-inline tw-ml-2 lg:tw-ml-4 tw-bg-aloe tw-rounded-full lg:tw-flex tw-px-3 tw-py-1 tw-text-xxs tw-items-center tw-font-medium'>
								<TabletAndBelow>
									{selectedCitiesCount}
								</TabletAndBelow>
								<Desktop>
									{selectedCitiesCount} {selectedCitiesCount === 1 ? 'city' : 'cities'} selected
								</Desktop>
							</span>
						)}
					</h4>
				</div>

				<button
					type="button"
					onClick={() => setIsCitiesOpen( ! isCitiesOpen )}
					className='tw-bg-transparent tw-absolute tw-right-0 tw-top-0 lg:tw-top-1'
					aria-expanded={isCitiesOpen}
					aria-label={isCitiesOpen ? 'Hide cities' : 'Show cities'}>
					<span className={`tw-block tw-p-2 ${ isCitiesOpen ? 'tw-rotate-180' : '' }`}>
						<IconCaret />
					</span>
				</button>
			</div>
			<div className={`${ isCitiesOpen ? '' : 'tw-hidden' }`}>
				<p className="tw-mb-6 tw-text-charcoal tw-text-xxs tw-font-normal">Select as many as you'd like</p>
				<SearchFiltersCities />
			</div>
		</div>
	);
};

export default SearchCitySelector;
